import type { Ref } from 'vue';

import { ref } from 'vue';

export interface SearchSuggestBackupOptions<TLocation = any> {
	searchTerm: Ref<string>;
	hasSelectedValue: Ref<boolean>;
	selectedLocation?: Ref<TLocation | null>;
	onRestoreSearchTerm?: () => void;
}

export function useSearchSuggestBackup<TLocation = any>(
	options: SearchSuggestBackupOptions<TLocation>
) {
	const {
		searchTerm,
		hasSelectedValue,
		selectedLocation,
		onRestoreSearchTerm
	} = options;

	const backupSearchTerm = ref<string>('');
	const backupHasSelectedValue = ref<boolean>(false);
	const backupSelectedLocation = ref<TLocation | null>(null);

	function extractBackup() {
		if (hasSelectedValue.value) {
			backupSearchTerm.value = searchTerm.value;
			backupHasSelectedValue.value = true;
			if (selectedLocation) {
				backupSelectedLocation.value = selectedLocation.value;
			}
		} else {
			backupSearchTerm.value = '';
			backupHasSelectedValue.value = false;
			if (selectedLocation) {
				backupSelectedLocation.value = null;
			}
		}
	}

	function clearBackup() {
		backupSearchTerm.value = '';
		backupHasSelectedValue.value = false;
		if (selectedLocation) {
			backupSelectedLocation.value = null;
		}
	}

	function restoreOrClearOnClose(fallbackClearSearchTerm = true) {
		if (!hasSelectedValue.value) {
			if (backupHasSelectedValue.value || backupSearchTerm.value) {
				onRestoreSearchTerm?.();
				searchTerm.value = backupSearchTerm.value;
				hasSelectedValue.value = true;
				if (selectedLocation && backupSelectedLocation.value) {
					selectedLocation.value = backupSelectedLocation.value as any;
				}
			} else if (fallbackClearSearchTerm) {
				onRestoreSearchTerm?.();
				searchTerm.value = '';
			}
		}

		clearBackup();
	}

	return {
		backupSearchTerm,
		backupHasSelectedValue,
		backupSelectedLocation,
		extractBackup,
		clearBackup,
		restoreOrClearOnClose
	};
}
